import React, { createContext, useContext, useState, useEffect } from 'react';
import { rolePermissionsAPI } from '../services/api';
import { useAuth } from './AuthContext';

const PermissionsContext = createContext({ can: () => true, navPaths: null });

// ROLE_DEFAULTS mirrors the backend seeds — used as the instant fallback
// before the API responds so the UI never flickers on first render.
const ROLE_DEFAULTS = {
  admin:       ['/', '/properties', '/apartments', '/payments', '/work-orders', '/leases', '/tenants', '/inventory', '/documents', '/expenses', '/budget', '/notifications', '/users', '/role-permissions', '/settings'],
  manager:     ['/', '/properties', '/apartments', '/payments', '/work-orders', '/leases', '/tenants', '/inventory', '/documents', '/expenses', '/notifications'],
  maintenance: ['/', '/work-orders', '/inventory', '/notifications'],
  accountant:  ['/', '/payments', '/leases', '/documents', '/notifications'],
  contractor:  ['/work-orders'],
  tenant:      ['/', '/payments', '/work-orders', '/leases', '/documents', '/notifications'],
};

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [crudPerms, setCrudPerms] = useState({});
  const [navPaths,  setNavPaths]  = useState(() => ROLE_DEFAULTS[user?.role] || []);

  useEffect(() => {
    if (!user?.role) return;
    rolePermissionsAPI.getAll()
      .then(r => {
        const entry = r.data.data.find(p => p.role === user.role);
        if (entry) {
          setCrudPerms(entry.crud || {});
          setNavPaths(entry.paths || []);
        }
      })
      .catch(() => {});
  }, [user?.role]);

  const can = (module, action) => {
    if (user?.role === 'admin') return true;
    return crudPerms[module]?.[action] ?? true; // default true while loading
  };

  return (
    <PermissionsContext.Provider value={{ can, navPaths }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export const usePermissions = () => useContext(PermissionsContext);
